import { useCallback } from 'react'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { oneDotAfterNames } from '../model/names'

/** `useSmartTranslation`, whose `t_` leaves a single period after a name that already ends in one (RN77, A202-16). */
export const useNamesTranslation = () => {
  const translation = useSmartTranslation()
  const { t_ } = translation
  const withNames = useCallback((key, params) => oneDotAfterNames(t_(key, params), params), [t_])
  return { ...translation, t_: withNames }
}
